import { render, staticRenderFns } from "./ForwardButton.vue?vue&type=template&id=36b3054a"
import script from "./ForwardButton.vue?vue&type=script&lang=ts"
export * from "./ForwardButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports